import React from "react";
import "./Banner.scoped.scss";

interface IBannerProps {
  type: BannerType,
  children: any,
  closeButton?: boolean,
  onCloseBanner?: () => void;
}

export enum BannerType {
  Info = "info",
  Warn = "warn",
  Error = "error",
  Success = "success"
}

const Banner: React.FC<IBannerProps> = (props) => {

  const handleClick = () => {
    if (props.onCloseBanner) {
      props.onCloseBanner();
    }
  }

  return (
    <div className={props.type}>
      {props.children}
      {props.closeButton &&

        <button
          className="closeButton"
          onClick={handleClick}
        >
          X
        </button>

      }
    </div>
  );
};

export default Banner;